// Duplicated from devsite's modules/common/util/wconsole, trimmed to the log/error calls this
// package actually makes. The devsite original gates `log` behind TOGGLE_DETAILED_BROWSER_LOGGING
// (an env/localStorage-driven toggle); this package has no equivalent toggle system yet, so `log`
// always logs, matching `error`'s existing always-on behavior.
const log = (message: unknown, ...optionalParams: unknown[]) => {
  // eslint-disable-next-line no-console
  console.log(message, ...optionalParams);
};

// error logs are always shown in users' console in case Support needs more info from them, etc.
const error = (message: unknown, ...optionalParams: unknown[]) => {
  // eslint-disable-next-line no-console
  console.error(message, ...optionalParams);
};

const wconsole = { log, error };

export default wconsole;
